import { createFileRoute } from "@tanstack/react-router";
import IRSFormDetail from "@/pages/site/IRSFormDetail";

export const Route = createFileRoute("/resources/irs-forms/$slug")({
  component: () => <IRSFormDetail />,
});
